import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import { CopyService } from '../../../service/copy.service';
import { LocationService } from 'src/app/shared/service/location.service';
import { MailRegisterService } from 'src/app/shared/service/mail-register.service';
import { MailInfo } from '../../../model/mail-info.model';
import { MatchingOffer } from 'src/app/shared/model/matching-offer.model';
import { RejectReason } from '../../../model/mail-reject-reasons';
import { LeaveOnlyImportantLinePipe } from 'src/app/shared/pipe/leave-only-important-line.pipe';

import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { ActionLogForOffer } from '../../../model/action-log-for-offer.model';
import { PageEnums } from 'src/app/shared/enum/page-enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { MailCustomTagRegisterComponent } from '../../../modal/mail-custom-tag-register/mail-custom-tag-register.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit, OnChanges, OnDestroy {
  // TODO create a base model cotains all attributes and share same refrence across all parts of card
  @Input() mailInfo: MailInfo;
  @Input() mailType: 'project' | 'worker';
  @Input() page: string; // 存在するページ
  @Input() pairMail: MailInfo; // ペアメール
  @Input() baseKeywords: Array<string> = [];
  @Input() displayStatus = 3;
  @Input() clickableArea = 0;
  @Input() sharedAccountOffers: MatchingOffer[]; // 共通アカウント（USER_CODE）に紐付くオファーを取得
  @Input() offeredMailIds: number[]; // offersの中のmail_id
  @Input() rejectReason: RejectReason;

  @Input() searchParams: SearchCondition;

  @Input() actionLogId: number;
  @Input() actionLog: ActionLogForOffer;
  @Input() offer: any = null;
  @Input() result: any; // 自動マッチングページの提案管理送信済みフラグ(result.matching.is_already_offerd)を変更するために使用

  @Input() stickyHeaderOffset = '0';

  @Output() deleted = new EventEmitter<any>();
  @Output() changeStatus = new EventEmitter<any>();
  @Output() click_card = new EventEmitter<any>();
  @Output() closeCard = new EventEmitter<void>();
  public cardHeaderEditEvent = new EventEmitter<void>();

  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    public leaveOnlyImportantLinePipe: LeaveOnlyImportantLinePipe,
    public locationService: LocationService,
    public copyService: CopyService,
    private mailRegisterService: MailRegisterService,
    private toastrService: ToastrService,
    private router: Router
  ) {}

  workerMail: MailInfo;
  projectMail: MailInfo;
  offerType: string; // 1:案件確認依頼, 2:人材確認依頼
  ngOnInit() {
    this.setWorkerProject();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.mailInfo) {
      this.setWorkerProject();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  setWorkerProject() {
    if (this.mailType === 'worker') {
      this.workerMail = this.mailInfo;
      this.projectMail = this.pairMail;
      this.offerType = 'project';
    } else if (this.mailType === 'project') {
      this.workerMail = this.pairMail;
      this.projectMail = this.mailInfo;
      this.offerType = 'worker';
    }
  }
  clickPart(part: number) {
    if (part <= this.clickableArea) {
      this.click_card.emit();
    }
  }
  isOfferPage(): boolean {
    return this.page === PageEnums.offer;
  }
  openTagRegister() {
    const modalRef = this.modalService.open(MailCustomTagRegisterComponent);
    modalRef.componentInstance.mailType = this.mailType;
    modalRef.componentInstance.mailInfo = this.mailInfo;
  }

  sendToRegister() {
    const sendSub = this.mailRegisterService
      .sendToRegister(this.mailInfo.id, this.mailType)
      .subscribe({
        next: _ => this.toastrService.success('案件人材管理に追加しました'),
        error: err => {
          switch (err.status) {
            case 409:
              this.toastrService.warning('案件人材管理に存在しています');
              break;

            default:
              this.toastrService.error('失敗しました');
          }
        }
      });
    this.subscriptions.add(sendSub);
  }

  // 一覧ページかどうか
  isIndexPage(): boolean {
    const url = this.router.url;
    return !!url.match(/matching\/(projects|workers)$/);
  }

  // カードを閉じるボタン
  onCloseButtonClick() {
    this.closeCard.emit();
  }
}
